<template>
  <div v-if="showError">
    <weex-text class="font-size-sm-base text-color-red">{{errorMsg}}</weex-text>
  </div>
</template>

<script>

  export default {
    name: "FieldErrorItem",
    props: {
      showError: {
        type: Boolean,
        required: true,
        default: false,
      },

      errorMsg: {
        type: String,
        required: true
      }
    }
  };
</script>

<style
  scoped
  src="../../assets/style/base.css"></style>
